import React, { ReactNode, useMemo } from 'react';
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { Option, Select } from 'carbon-react/lib/components/select';

import { PredictionType } from '../../types';

import styles from './prediction-header-bar.scss';

interface PredictionHeaderBarProps {
  children?: ReactNode;
  isEditing?: boolean;
  onChangePredictionType: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  options: PredictionType[];
  predictionType: PredictionType | null;
  wrap?: boolean;
}

export const PredictionHeaderBar = ({
  children,
  isEditing,
  onChangePredictionType,
  options,
  predictionType,
  wrap
}: PredictionHeaderBarProps) => {
  const intl = useIntl();

  const DEFAULT_TEXT = useMemo(
    () => ({
      [PredictionType.FORMULA]: intl.formatMessage({ id: 'common.formula', defaultMessage: 'Formula' }),
      [PredictionType.FREESTYLE]: intl.formatMessage({ id: 'predict.freestyle', defaultMessage: 'Freestyle' }),
      [PredictionType.REPEATING]: intl.formatMessage({ id: 'common.repeating', defaultMessage: 'Repeating' }),
      [PredictionType.UNIT]: intl.formatMessage({ id: 'common.unit', defaultMessage: 'Unit' })
    }),
    [intl]
  );

  return (
    <div className={clsx(styles.container, { [styles.wrap]: wrap })}>
      <div className={styles.formInput}>
        <Select
          autoComplete="off"
          onChange={onChangePredictionType}
          value={predictionType || ''}
          label={intl.formatMessage({ id: 'predict.prediction_method', defaultMessage: 'Prediction method' })}
          disabled={isEditing}
          size="large"
          mb={0}
        >
          {options.map(option => (
            <Option key={option} text={DEFAULT_TEXT[option]} value={option} />
          ))}
        </Select>
      </div>
      {children}
    </div>
  );
};
